"use strict";

module.exports = function () {
    return {
        restrict: "AE",
        replace: true,
        scope: {
            resident: "=",
            iluAllocationId: "=",
            iluStatus: "="
        },
        controller: "residentDetails.controller",
        templateUrl: "app/residents/directives/partials/residentDetails.html"
    };
}
